import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import * as firebase from 'firebase';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRestWebSchedulePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-rest-web-schedule',
  templateUrl: 'configuration-rest-web-schedule.html',
})
export class ConfigurationRestWebSchedulePage {

  public form: FormGroup;
  public firestore: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.firestore = firebase.firestore();
  }

  async ionViewDidEnter() {
  }

  async updateSchedule() {

    this.checkValueUndefined();

    await this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'web_schedule_monday': this.globals.restaurant.web_schedule_monday,
      'web_schedule_tuesday': this.globals.restaurant.web_schedule_tuesday,
      'web_schedule_wednesday': this.globals.restaurant.web_schedule_wednesday,
      'web_schedule_thursday': this.globals.restaurant.web_schedule_thursday,
      'web_schedule_friday': this.globals.restaurant.web_schedule_friday,
      'web_schedule_saturday': this.globals.restaurant.web_schedule_saturday,
      'web_schedule_sunday': this.globals.restaurant.web_schedule_sunday,

    }).then(doc => {
      this.toast();
      this.navCtrl.pop();
    });
  }

  toast() {
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-horario-guardado'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  checkValueUndefined() {
    if (this.globals.restaurant.web_schedule_monday == undefined) {
      this.globals.restaurant.web_schedule_monday = '';
    }
    if (this.globals.restaurant.web_schedule_tuesday == undefined) {
      this.globals.restaurant.web_schedule_tuesday = '';
    }
    if (this.globals.restaurant.web_schedule_wednesday == undefined) {
      this.globals.restaurant.web_schedule_wednesday = '';
    }
    if (this.globals.restaurant.web_schedule_thursday == undefined) {
      this.globals.restaurant.web_schedule_thursday = '';
    }
    if (this.globals.restaurant.web_schedule_friday == undefined) {
      this.globals.restaurant.web_schedule_friday = '';
    }
    if (this.globals.restaurant.web_schedule_saturday == undefined) {
      this.globals.restaurant.web_schedule_saturday = '';
    }
    if (this.globals.restaurant.web_schedule_sunday == undefined) {
      this.globals.restaurant.web_schedule_sunday = '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rest-web/configuration-rest-web-schedule/configuration-rest-web-schedule.ts